document.querySelectorAll('[data-content-filters]').forEach((form) => {
  const submit = () => {
    const url = new URL(form.action || window.location.href, window.location.origin);
    const data = new FormData(form);

    data.forEach((value, key) => {
      if (String(value).trim() !== '') {
        url.searchParams.set(key, String(value));
      } else {
        url.searchParams.delete(key);
      }
    });

    window.location.assign(url.toString());
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    submit();
  });

  form.querySelectorAll('select').forEach((select) => {
    select.addEventListener('change', submit);
  });
});
